export default __webpack_public_path__ + "static/media/coal_mount_icon.6dc023bd.svg";